/**
 * Decode the payload of a JWT and extract the `exp` claim (expiration, in ms since epoch).
 * Returns null if the token is malformed, unparseable, or has no numeric `exp`.
 *
 * JWT uses base64url encoding (RFC 7515): `-` instead of `+`, `_` instead of `/`,
 * and no `=` padding. `atob` requires standard base64, so we normalise before decoding.
 *
 * This is a client-side UX helper only — the server verifies the HMAC signature.
 */
export function getJwtExp(token: string): number | null {
  try {
    const raw = token.split('.')[1];
    if (!raw) return null;
    const base64 = raw.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const payload = JSON.parse(atob(padded));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}
